import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";
import Alert from "react-bootstrap/Alert";
import { withRouter } from "react-router-dom";
import CancelModal from "../../../../components/cancel-modal/cancel-modal";
import ConfirmationModal from "../../../../components/confirmation-modal/confirmation-modal";
import {
  GetDepartmentAPI,
  EditDepartmentAPI,
  CreateDepartmentAPI,
} from "../../../../services/api/department-api";
import { LoginContext } from "../../../../services/api/authentication-api";
import AdminDepartmentFormNew from "./admin-department-form-new";
import "./admin-department-create-panel.scss";

export const dateFormats = [
  { id: 1, name: "DD/MM/YYYY" },
  { id: 2, name: "MM/DD/YYYY" },
];

const AdminDepartmentCreatePanelNew = (props) => {
  const isEdit = props.location.pathname.split("/")[4] === "edit";
  const [department, setDeparment] = useState({
    data: {
      PhotoAdded: false,
      SelectedDateFormat: { id: 2, name: "MM/DD/YYYY" },
      Id: 0,
      Name: "",
      Zip: "",
      City: "",
      State: "",
      Country: "",
      CreatedBy: 0,
      CreatedDate: new Date(),
      IsSuperAdmin: false,
      WebsiteURL: "",
      Active: false,
      Address: "",
      IsAppointmentEnable: false,
      IsMessengerServiceEnable: false,
      ExchangeServerURL: "",
      ExchangeServerUserName: "",
      ExchangeServerPassword: "",
      CompanyLogo: "",
      DepartmentImageRaw: "",
      ...props.department,
    },
    Isloading: true,
  });
  const [alertConfig, setAlertConfig] = useState({
    showAlert: false,
    alertAction: "",
    alertMessage: "",
    alertVariant: "danger",
  });
  const [panelVisibility, setPanelVisibility] = useState({
    showCancelPanel: false,
    showConfirmPanel: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (isEdit) {
          let result = await GetDepartmentAPI(
            props.location.pathname.split("/")[5]
          );
          setDeparment((prev) => ({
            ...prev,
            data: {
              ...result.data,
              PhotoAdded:
                result.data.CompanyLogo && result.data.CompanyLogo !== "",
              SelectedDateFormat: dateFormats.find(
                (df) => df.id === result.data.DateFormatId
              ),
            },
            Isloading: false,
          }));
        }
      } catch (error) {
        setAlertConfig({
          showAlert: true,
          alertAction: "Cannot Get Department",
          alertMessage: error.toString(),
          alertVariant: "danger",
        });
      }
    };
    fetchData();
  }, []);

  const saveDepartment = async (values, actions) => {
    let newDepartment = {
      ...values,
      DateFormatId: values.SelectedDateFormat.id,
    };
    if (!values.PhotoAdded) {  
      newDepartment.DepartmentImageRaw = "";
      newDepartment.CompanyLogo = "";
  }
    try {
      await updateDepartment(newDepartment, actions);
    } catch (error) {
      console.log(error);
    }
  };

  const updateDepartment = async (values, actions) => {
    try {
      let result;

      // The backend (`UploadImageToServerFromBase64` in TriyoCore.Service.Utilities)
      // calls Convert.FromBase64String, which throws on the "data:image/<mime>;base64,"
      // prefix. Strip it for any image MIME — including ones with `+`, `-`, or `.`
      // (e.g. svg+xml, x-icon, vnd.microsoft.icon) — so we never send a data URL
      // to the API. Applies to both create and edit.
      if (values.DepartmentImageRaw && values.DepartmentImageRaw.startsWith("data:image")) {
        values.DepartmentImageRaw = values.DepartmentImageRaw.replace(
          /^data:image\/[^;]+;base64,/,
          ""
        );
      }

      if (!isEdit) {
        result = await CreateDepartmentAPI(values);
      } else {
        result = await EditDepartmentAPI(values);
      }

      if (result.status !== 200) {
        setAlertConfig((prev) => ({
          ...prev,
          showAlert: true,
          alertAction: "A department with that name exists",
          alertMessage: "",
          alertVariant: "danger",
        }));
        actions.setSubmitting(false);
        return;
      }

      setPanelVisibility((prev) => ({ ...prev, showConfirmPanel: true }));
      actions.setSubmitting(false);
    } catch (error) {
      console.log(error);
      setAlertConfig((prev) => ({
        ...prev,
        showAlert: true,
        alertAction: !isEdit
          ? "Cannot Create New Department"
          : "Cannot Update Department",
        alertMessage: error.toString(),
        alertVariant: "danger",
      }));
      actions.setSubmitting(false);
    }
  };

  return (
    <div className="department-edit-panel">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {isEdit
            ? "TRIYO · " + department.data?.Name
            : "TRIYO · Create Department"}
        </title>
      </Helmet>
      { alertConfig.showAlert &&
        <Alert
          show={alertConfig.showAlert}
          onClose={() =>
            setAlertConfig({
              showAlert: false,
            })
          }
          variant={alertConfig.alertVariant}
          dismissible
        >
          <Alert.Heading>{alertConfig.alertAction}</Alert.Heading>
          <p>{alertConfig.alertMessage}</p>
        </Alert>
      }
      { panelVisibility.showCancelPanel &&
        <CancelModal
          show={panelVisibility.showCancelPanel}
          onHide={() => {
            setPanelVisibility((prev) => ({ ...prev, showCancelPanel: false }));
          }}
          redirectURL={"/admin?tab=organization&subtab=departments"}
        />
      }
      { panelVisibility.showConfirmPanel &&
        <ConfirmationModal
          show={panelVisibility.showConfirmPanel}
          onHide={() => {
            props.history.push("/admin?tab=organization&subtab=departments");
          }}
          redirectURL={"/admin?tab=organization&subtab=departments"}
          header={!isEdit && "Create Department Confirmation"}
          confirmationText={
            !isEdit && "Department has been created successfully."
          }
        />
      }
      <h4 className="panel-title">
        {isEdit ? "Edit Department" : "Create Department"}
      </h4>
      <AdminDepartmentFormNew
        department={department}
        setDeparment={setDeparment}
        setAlertConfig={setAlertConfig}
        setPanelVisibility={setPanelVisibility}
        saveDepartment={saveDepartment}
        isEdit={isEdit}
      />
    </div>
  );
};

AdminDepartmentCreatePanelNew.propTypes = {
  department: PropTypes.object,
};

AdminDepartmentCreatePanelNew.contextType = LoginContext;

export default withRouter(AdminDepartmentCreatePanelNew);
